import "../../components/modal/ModalCss.scss";
import { Fragment, useEffect, useMemo, useState } from "react";
import BasicButton from "components/button/BasicButton";

/**
 * 추가 상품 표시 Component
 */
function SupplementProductDisplay (props) {

	const {supplementProducts, onClickAdd, onClickMod, onClickDel} = props;
	
	const getGrp = () => {

		if(supplementProducts == null || supplementProducts.length == 0) {
			return [];
		}

		if(supplementProducts.length == 1) {
			return [supplementProducts[0].groupName];
		}

		return supplementProducts
			.map(prd => prd.groupName)
			.reduce((acc, grp) => {
				if(!Array.isArray(acc)) {
					acc = [acc];
				}

				if(!acc.includes(grp)) {
					acc.push(grp);
				}

				return acc;
			});
	}
	const getSupplementProductsByGrp = (grp) => {
		return supplementProducts.filter(d => d.groupName === grp);
	}

	return (
		<>
			<BasicButton label="추가" className="btn-add" onClick={() => onClickAdd()} />
			<div>
				{getGrp().map((grp, idx) => (
					<div key={"grp_" + idx} style={idx > 0 ? {marginTop: "10px"} : {}}>
						<span>그룹: {grp}</span>
						<span style={{float: "right"}}>
							<BasicButton label="수정" className="btn-mod" onClick={() => onClickMod(grp)} />
							<div style={{width: "5px", display: "inline-block"}}></div>
							<BasicButton label="삭제" className="btn-del" onClick={() => onClickDel(grp)} />
						</span>
						<table className="table-styled">
							<colgroup>
								<col width="150"/>
								<col width="150"/>
								<col width="150"/>
								<col width="150"/>
							</colgroup>
							<thead>
								<tr>
									<th>이름</th>
									<th>가격</th>
									<th>수량</th>
									<th>사용여부</th>
								</tr>
							</thead>
							<tbody>
								{getSupplementProductsByGrp(grp).map((prd, idx) => (
									<tr key={"prd_" + grp+ "_" + idx}>
										<td>{prd.name}</td>
										<td>{prd.price}</td>
										<td>{prd.stockQuantity}</td>
										<td>{prd.usable ? "사용" : "미사용"}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				))}
			</div>
		</>
	);
}

export default SupplementProductDisplay;
